// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"488":"axiom","532":"styles","592":"common","736":"vendor"}[chunkId] || chunkId) + "." + {"241":"c7276650a0dbf7e3401e","488":"b2e7c0e1652d76295ffd","532":"8bbf4a81c065a9b9699d","592":"45071c695e091bd73b16","736":"b48d1a60b8de0940da58"}[chunkId] + ".js";
};